import $ from 'jquery'
import Splide from '@splidejs/splide'

if ( $('.story-block__slider').length != 0 ) {
    var storySplide = new Splide( '.story-block__slider', {
        drag   : 'free',
        arrows: false,
        pagination: false,
        fixedWidth : '275px',
        gap : '30px',
        wheel: true,
    } );

    storySplide.mount();
}
